const message = 'Wpisz poprawną kwotę'
export default {
    min: {
        value: 1,
        message,
    },
    max: {
        value: 9999999,
        message,
    }
}